export const language = [
    { id: 0, code: "ar", name: "العربية", englishName: "Arabic", market: "SA" },
    { id: 1, code: "zh", name: "中文", englishName: "Chinese", market: "TW" },
    { id: 2, code: "en", name: "English", englishName: "English", market: "US" },
    { id: 3, code: "fr", name: "Français", englishName: "French", market: "FR" },
    { id: 4, code: "de", name: "Deutsch", englishName: "German", market: "DE" },
    { id: 5, code: "he", name: "עברית", englishName: "Hebrew", market: "IL" },
    { id: 6, code: "hi", name: "हिन्दी", englishName: "Hindi", market: "IN" },
    { id: 7, code: "it", name: "Italiano", englishName: "Italian", market: "IT" },
    { id: 8, code: "ja", name: "日本語", englishName: "Japanese", market: "JP" },
    { id: 9, code: "ko", name: "한국어", englishName: "Korean", market: "KR" },
    { id: 10, code: "pt", name: "Português", englishName: "Portuguese", market: "BR" },
    { id: 11, code: "ru", name: "Русский", englishName: "Russian", market: "PL" },
    { id: 12, code: "es", name: "Español", englishName: "Spanish", market: "ES" },
    { id: 13, code: "sw", name: "Kiswahili", englishName: "Swahili", market: "KE" },
    { id: 14, code: "th", name: "ไทย", englishName: "Thai", market: "TH" },
    { id: 15, code: "vi", name: "Tiếng Việt", englishName: "Vietnamese", market: "VN" },
    { id: 16, code: "zu", name: "Zulu", englishName: "Zulu", market: "ZA" },
];